import { useEffect } from 'react';
import { Stack, Image, Link, Heading, Box } from '@telescope/cassini-ui';
import { Text } from 'components';
import { useWidget } from '@telescope/cassini-hooks';
import { BingoHeadline } from './BingoHeadline';
import TagManager from 'react-gtm-module';
import { TRACKING_ROUTES } from 'utils/constants';
import { Canvas, useAuth } from 'features';
import { Open } from 'generated-types/widget';

export const Results = () => {
  const { data } = useWidget({ select: (data: Open) => data.snapshot.snapshot_views.resultsPage });
  const { content: { win: winContent, lose: loseContent }} = data!;
  const { user } = useAuth();
  const { isWinner, prize } = user!;

  const prizeData = prize?.prize_data;
  const prizeImage = prizeData?.prize_content?.image.src;
  const defaultContent = isWinner? winContent : loseContent;

  const content = {
    ...defaultContent,
    image: prizeImage || defaultContent.image,
    imageAlt: prizeData?.prize_content?.image.alt || defaultContent.imageAlt,
    headline: prizeData?.winner_message?.title || defaultContent.headline,
    subheadline: prizeData?.winner_message?.subtitle || defaultContent.subheadline,
    link: prizeData?.link_out
  }

  useEffect(() => {
    TagManager.dataLayer({ dataLayer: { event: "pageView", pageTitle: TRACKING_ROUTES.GAME_OVER }});
    window.scrollTo( 0, 0 );
  }, []);

  return (
    <Stack spacing={4} textAlign="center">
      <BingoHeadline />

      { prizeImage && 
        <Canvas image={prizeImage} 
          alt={content.imageAlt || ''} 
          textStyles={prizeData.prize_content.text}
          text={prize?.prize_code} /> }

      { (!prizeImage && defaultContent.image) && 
        <Image src={defaultContent.image} alt={defaultContent.imageAlt} /> }

      <Text as={Heading} fontSize={{base: '4xl', lg: '5xl'}} allowMarkdown> 
        {content.headline} 
      </Text>

      <Text as="h3" allowMarkdown fontSize={{base: 'lg', md: 'xl'}}> 
        {content.subheadline} 
      </Text>

      <Text allowMarkdown fontSize={{base: 'md', md: 'lg'}}> 
        {content.description} 
      </Text>

      { content.link?.text && 
        <Box><Link href={content.link.href}> {content.link?.text} </Link></Box> }

    </Stack>
  )
}